<template>
	<section class="member-support">
		<el-row :gutter="16">
			<el-col :md="12" :xs="24">
				<el-card shadow="never">
					<div slot="header">
						快速工单
					</div>
					<el-form :model="form" label-width="90px">
						<el-form-item label="业务类型">
							<el-select v-model="form.type" placeholder="请选择">
								<el-option
									v-for="item in types"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								/>
							</el-select>
						</el-form-item>
						<el-form-item label="问题描述">
							<el-input
								v-model="form.desc"
								type="textarea"
								rows="4"
								placeholder="请描述问题，方便客服快速处理"
							/>
						</el-form-item>
						<el-form-item>
							<el-button type="primary">
								提交
							</el-button>
						</el-form-item>
					</el-form>
				</el-card>
			</el-col>
			<el-col :md="12" :xs="24">
				<el-card shadow="never">
					<div slot="header">
						客服与常见问题
					</div>
					<ul class="support-list">
						<li v-for="item in faqs" :key="item.title">
							<div class="faq-title">
								{{ item.title }}
							</div>
							<div class="faq-desc">
								{{ item.desc }}
							</div>
						</li>
					</ul>
					<el-alert
						title="24h 企业客服热线：400 606 0011"
						type="info"
						show-icon
					/>
				</el-card>
			</el-col>
		</el-row>
	</section>
</template>

<script>
export default {
	name: 'MemberSupport',
	data() {
		return {
			form: {
				type: 'Flight',
				desc: ''
			},
			types: [
				{ label: '机票', value: 'Flight' },
				{ label: '酒店', value: 'Hotel' },
				{ label: '签证', value: 'Visa' },
				{ label: '保险', value: 'Insurance' },
				{ label: '欧铁', value: 'Europe' }
			],
			faqs: [
				{
					title: '如何查看企业审批进度？',
					desc: '可在订单详情页查看审批节点，也可在企业微信收到提醒。'
				},
				{
					title: '发票多久可以开具？',
					desc: '订单完成且财务审核通过后 3 个工作日内开票。'
				},
				{
					title: '如何批量导入常旅客？',
					desc: '在常旅客模块下载模板，填写后上传并校验。'
				}
			]
		}
	}
}
</script>

<style lang="scss" scoped>
.support-list {
	list-style: none;
	padding: 0;
	margin: 0 0 16px;

	li + li {
		margin-top: 12px;
	}
}

.faq-title {
	font-weight: 600;
}

.faq-desc {
	font-size: 13px;
	color: #606266;
}
</style>

